import React from "react";
import PropTypes from "prop-types";
import Loader from "react-loaders";

import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { replace } from "connected-react-router";
import { Route } from "react-router-dom";
import { toast } from "react-toastify";

import Header from "components/Header";
import ParkkiTheme from "themes/ParkkiTheme";
import PermissionsActioner from "services/permissions/actioner";
import UserUtils from "services/user/utils";
import paths from "routes/paths";

const styles = {
  loaderContainer: {
    display: "flex",
    flex: 1,
    backgroundColor: "rgba(236, 235, 235, 0.5)",
    height: "100%",
    justifyContent: "center",
  },
};
class PermissionRoute extends React.PureComponent {
  isComponentMounted = false;

  state = {
    initialized: false,
    hasAccess: false,
  };

  componentDidMount() {
    const { accessPermission, authenticated, hasAccess, replace, user } =
      this.props;

    this.isComponentMounted = true;

    if (!authenticated) {
      toast(this.props.intl.messages["toast.errors.authRequired"], {
        position: toast.POSITION.BOTTOM_RIGHT,
        type: toast.TYPE.ERROR,
      });

      return this.props.replace(paths.front.login);
    }

    if (!accessPermission) {
      return (
        this.isComponentMounted &&
        this.setState({ hasAccess: true, initialized: true })
      );
    }

    return hasAccess(accessPermission.name, accessPermission.subject).then(
      (access) => {
        if (!access) {
          replace(UserUtils.getDefaultRoute(user));

          return toast(this.props.intl.messages["toast.errors.access"], {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
        }

        return (
          this.isComponentMounted &&
          this.setState({ hasAccess: true, initialized: true })
        );
      }
    );
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  renderLoader = () => (
    <div style={styles.loaderContainer}>
      <Loader
        style={{ marginTop: "40px" }}
        color={ParkkiTheme.colors.blue}
        type="ball-beat"
      />
    </div>
  );

  render() {
    const {
      component: Component,
      authenticated,
      replace,
      ...rest
    } = this.props;
    const { hasAccess, initialized } = this.state;

    if (!initialized) {
      return this.renderLoader();
    }

    return (
      <>
        <Header />
        <Route
          {...rest}
          render={() =>
            hasAccess ? <Component {...this.props} /> : this.renderLoader()
          }
        />
      </>
    );
  }
}

PermissionRoute.defaultProps = {
  authenticated: false,
  component: null,
  exact: false,
};

PermissionRoute.propTypes = {
  accessPermission: PropTypes.shape({
    name: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
  }).isRequired,
  authenticated: PropTypes.bool,
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.elementType,
    PropTypes.element,
  ]),
  exact: PropTypes.bool,
  hasAccess: PropTypes.func.isRequired,
  path: PropTypes.string,
  replace: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  hasAccess: (right, permissionName) =>
    dispatch(PermissionsActioner.hasAccess(right, permissionName)),
  replace: (path) => dispatch(replace(path)),
});

const mapStateToProps = (state) => ({
  authenticated: state.Authentication.isAuthenticated,
  user: state.User,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(PermissionRoute));
